import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sukana_cart") || "[]"); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem("sukana_cart", JSON.stringify(items));
  }, [items]);

  const add = useCallback((item) => {
    setItems((prev) => {
      const found = prev.find((p) => p.item_id === item.item_id && p.kind === item.kind);
      if (found) {
        return prev.map((p) => p.item_id === item.item_id && p.kind === item.kind
          ? { ...p, quantity: p.quantity + (item.quantity || 1) } : p);
      }
      return [...prev, { ...item, quantity: item.quantity || 1 }];
    });
  }, []);
  const remove = useCallback((item_id, kind) => setItems((prev) => prev.filter((p) => !(p.item_id === item_id && p.kind === kind))), []);
  const setQty = useCallback((item_id, kind, quantity) => setItems((prev) =>
    prev.map((p) => p.item_id === item_id && p.kind === kind ? { ...p, quantity: Math.max(1, quantity) } : p)), []);
  const clear = useCallback(() => setItems([]), []);

  const value = useMemo(() => {
    const count = items.reduce((s, i) => s + i.quantity, 0);
    const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
    return { items, add, remove, setQty, clear, count, total };
  }, [items, add, remove, setQty, clear]);

  return <CartCtx.Provider value={value}>{children}</CartCtx.Provider>;
}

export const useCart = () => useContext(CartCtx);
